import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { ProductSearchResultItemNowDialogDynamicContent } from './ProductSearchResultItemNowDialogDynamicContent'

export const ProductSearchResultItemNowDialog: FC<{
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose }) => {
  return (
    <Dialog onClose={onClose} open={isOpen}>
      <DialogTitle onClose={onClose}>
        <FormattedMessage id="general.label.now.title" />
      </DialogTitle>
      <DialogContent className="flex-col">
        <ProductSearchResultItemNowDialogDynamicContent />
      </DialogContent>
    </Dialog>
  )
}
